"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const sourcemapped_stacktrace_1 = require("sourcemapped-stacktrace");
const ObjUtils_1 = require("./ObjUtils");
const serializeRequest_1 = tslib_1.__importDefault(require("./serializeRequest"));
const serializeResponse_1 = tslib_1.__importDefault(require("./serializeResponse"));
const getStackTrace = (error) => new Promise((resolve) => {
    (0, sourcemapped_stacktrace_1.mapStackTrace)(error.stack, (mappedStack) => resolve([String(error), ...mappedStack].join("\n")));
});
const isErrorEvent = (error) => {
    return error && error.lineno && error.filename;
};
const coreApiErrorNames = ["RawQueryError", "JsonQueryError", "BlobQueryError"];
const isCoreApiError = (error) => {
    return Boolean(error && coreApiErrorNames.indexOf(error.name) > -1);
};
async function serializeException(error, context) {
    let localContext = {};
    let stacktrace;
    if (isCoreApiError(error)) {
        stacktrace = await getStackTrace(error.error);
        localContext = {
            ...(0, ObjUtils_1.flatten)((0, serializeRequest_1.default)(error.request), { prefix: "request" }),
            ...(error.response ? (0, ObjUtils_1.flatten)((0, serializeResponse_1.default)(error.response), { prefix: "response" }) : {}),
            name: error.error.name,
        };
    }
    else if (isErrorEvent(error)) {
        stacktrace = await getStackTrace(error.error);
        localContext = {
            ...context,
            name: error.error.name,
            filename: error.filename,
            lineno: error.lineno,
            colno: error.colno,
        };
    }
    else {
        stacktrace = await getStackTrace(error);
        localContext = {
            name: error.name,
        };
    }
    return {
        clientBrowser: navigator.userAgent,
        timestamp: new Date().getTime(),
        message: error.message,
        stacktrace,
        context: localContext,
    };
}
exports.default = serializeException;
